"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVICE_TYPE = void 0;
__exportStar(require("./dto"), exports);
__exportStar(require("./apiconnection"), exports);
__exportStar(require("./resources"), exports);
__exportStar(require("./util"), exports);
var DEVICE_TYPE;
(function (DEVICE_TYPE) {
  DEVICE_TYPE["PFEXTERN"] = "de.fivepont.extern";
  DEVICE_TYPE["PFOTHER"] = "de.fivepoint.pftime.other";
  DEVICE_TYPE["PFTIME_IOS"] = "de.fivepoint.pftime.ios";
  DEVICE_TYPE["PFTIME_ANDROID"] = "de.fivepoint.pftime.android";
  DEVICE_TYPE["PFCHATBROWSER"] = "de.fivepoint.pfchat.other";
  DEVICE_TYPE["PFAPIEXPLORER"] = "de.fivepoint.apiexplorer";
  DEVICE_TYPE["PFFILECONNECTOR"] = "de.fivepoint.pffileconnector";
})(DEVICE_TYPE = exports.DEVICE_TYPE || (exports.DEVICE_TYPE = {}));
